(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wellbeing-discount-filter"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-discount-listing]');
  if (!root) return;
  const select = root.querySelector('#DiscountCategory');
  const grid = root.querySelector('.wb-grid');
  const status = root.querySelector('.wb-filter-status');
  const pagination = root.querySelector('.wb-pagination');
  const original = grid.innerHTML;
  let allCards;
  let pending;
  let version = 0;
  async function loadCards() {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    let next = url.href;
    const visited = new Set();
    const cards = [];
    while (next && !visited.has(next)) {
      visited.add(next);
      const response = await fetch(next, {credentials: 'same-origin'});
      if (!response.ok) throw new Error('Unable to load products');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const listing = doc.querySelector('[data-discount-listing]');
      if (!listing) throw new Error('Missing collection');
      cards.push(...listing.querySelectorAll('[data-discount-product]'));
      const link = listing.querySelector('.wb-pagination .next a');
      next = link ? new URL(link.getAttribute('href'), url.origin).href : null;
    }
    return cards;
  }
  select.addEventListener('change', async () => {
    const current = ++version;
    const category = select.value;
    if (!category) {
      grid.innerHTML = original;
      grid.removeAttribute('aria-busy');
      if (pagination) pagination.hidden = false;
      status.textContent = '';
      return;
    }
    status.textContent = status.dataset.loading;
    grid.setAttribute('aria-busy', 'true');
    try {
      if (!allCards) {
        if (!pending) pending = loadCards().finally(() => { pending = null; });
        allCards = await pending;
      }
      if (current !== version) return;
      const matching = allCards.filter(card => card.dataset.categories.split(/\s+/).includes(category));
      grid.replaceChildren(...matching.map(card => card.cloneNode(true)));
      if (pagination) pagination.hidden = true;
      status.textContent = matching.length ? '' : status.dataset.empty;
    } catch (error) {
      if (current === version) status.textContent = status.dataset.error;
    } finally {
      if (current === version) grid.removeAttribute('aria-busy');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
